import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TareaDetalleService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  // Seccion de Tarea Detalle
  getTareaDetalle(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetalles', { headers: this.header(this.token) });
  }

  getTareaDetalleById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetalle/' + id, { headers: this.header(this.token) });
  }

  postTareaDetalle(tareaDetalle: any): Observable<any> {//fRnk    
    return this.http.post(this.baseUrl + 'poaTareaDetallePresupuesto', tareaDetalle, { headers: this.header(this.token) });
  }

  putTareaDetalle(data: any): Observable<any> {//fRnk    
    return this.http.put(this.baseUrl + 'poaTareaDetallePresupuesto', data, { headers: this.header(this.token) });
  }

  putTareaDetalleOperacion(data: any): Observable<any> {//fRnk
    return this.http.put(this.baseUrl + 'putCambiaTareaDetalleOperacionId', data, { headers: this.header(this.token) });
  }

  deleteTareaDetalle(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaTareaDetalle/' + id, { headers: this.header(this.token) });
  }

  // Seccion de Tarea Detalle Financiador
  getTareaDetFinanciador(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetalleFinanciadores', { headers: this.header(this.token) });
  }

  getTareaDetFinanciadorById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetalleFinanciador/' + id, { headers: this.header(this.token) });
  }

  postTareaDetFinanciador(tareaDFinanciador: any): Observable<any> {
    return this.http.post(this.baseUrl + 'poaTareaDetalleFinanciador', tareaDFinanciador, { headers: this.header(this.token) });
  }

  putTareaDetFinanciador(id: number, tareaDetFinanciador: any): Observable<any> {
    return this.http.put(this.baseUrl + 'poaTareaDetalleFinanciador/' + id, tareaDetFinanciador, { headers: this.header(this.token) });
  }

  deleteTareaDetFinanciador(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaTareaDetalleFinanciador/' + id, { headers: this.header(this.token) });
  }

  // Seccion de Tarea Detalle Mensual
  getTareaDetMensual(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetalleMensuales', { headers: this.header(this.token) });
  }

  getTareaDetMensualById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetalleMensual/' + id, { headers: this.header(this.token) });
  }

  postTareaDetMensual(tareaDFinanciador: any): Observable<any> {
    return this.http.post(this.baseUrl + 'poaTareaDetalleMensual', tareaDFinanciador, { headers: this.header(this.token) });
  }

  putTareaDetMensual(id: number, tareaDetMensual: any): Observable<any> {
    return this.http.put(this.baseUrl + 'poaTareaDetalleMensual/' + id, tareaDetMensual, { headers: this.header(this.token) });
  }

  deleteTareaDetMensual(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaTareaDetalleMensual/' + id, { headers: this.header(this.token) });
  }

  getTareasByAE(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareasPresupuestos/' + id, { headers: this.header(this.token) });
  }
  //fRnk
  getTareaDetallePresupuestoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaTareaDetallePresupuestoById/' + id, { headers: this.header(this.token) });
  }

  getSumaMontosByTecho(data: any): Observable<any> {
    return this.http.get(this.baseUrl + 'getSumaMontosByTecho/' + data.id + '/' + data.monto, { headers: this.header(this.token) });
  }

  getTareaDetalleFinanciadorById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getTareaDetalleFinanciador/' + id, { headers: this.header(this.token) });
  }

  postTareaDetalleFinanciador(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'tareaDetalleFinanciadorModifica', bodyString, { headers: this.header(this.token) });
  }

  postAdicionaTareaDetalleFinanciador(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'tareaDetalleFinanciadorAdiciona ', bodyString, { headers: this.header(this.token) });
  }

  putDescripcionPartida(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'updateDescripcionPartida ', bodyString, { headers: this.header(this.token) });
  }
}
